import { render, staticRenderFns } from "./FrecuencyField.vue?vue&type=template&id=2ac37a4a&scoped=true"
import script from "./FrecuencyField.vue?vue&type=script&lang=js"
export * from "./FrecuencyField.vue?vue&type=script&lang=js"
import style0 from "./FrecuencyField.vue?vue&type=style&index=0&id=2ac37a4a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ac37a4a",
  null
  
)

export default component.exports